/*
  validateAnswer
  - Minimal validation for quick wins phase
  - Trims strings; ensures arrays are arrays; leaves deeper business rules for later
*/

export default function validateAnswer(subq, raw) {
  if (raw === undefined) return undefined;
  if (raw === null) return null;

  const type = subq?.inputType;
  if (type === 'freeText' || type === 'freeTextArea' || type === 'freeTextNumerical') {
    if (typeof raw === 'string') return raw.trim();
    return raw;
  }
  if (type === 'selectMultiple') {
    return Array.isArray(raw) ? raw : (raw ? [raw] : []);
  }
  // Other types pass-through
  return raw;
}


